<template>
  <div>
    <div
      class="content-devx content-dx-daily-planning no-shadow no-margin"
    >
      <DxForm
        id="form"
        :col-count="1"
      >
        <DxSimpleItem
          :editor-options="{
            items: supervisorsAvailables,
            searchEnabled: true,
            searchTimeout: searchTimeoutOption,
            minSearchLength: minSearchLengthOption,
            showDataBeforeSearch: showDataBeforeSearchOption,
            onValueChanged: onSupervisorChange,
            readOnly: readOnly,
            displayExpr: 'fullname',
            valueExpr:'id',
          }"
          editor-type="dxSelectBox"
          :caption="$t('SelectSupervisor_supervisor_caption')"
        >
          <DxRequiredRule :message="$t('DxSelectSupervisor')" />
        </DxSimpleItem>
        <DxSimpleItem
          editor-type="dxTextArea"
          :editor-options="{
            placeholder: $t('DxInformationPrescription_notes_caption'),
            value: additionalInfo,
            onValueChanged: additionalInfoEvent,
            maxLength: 256,
          }"
        />
      </DxForm>
    </div>
  </div>
</template>
<script>
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
} from 'devextreme-vue/form';
import * as overlay from 'devextreme/ui/overlay';
import { mapActions } from 'vuex';

export default {
  name: 'DxSelectSupervisor',
  components: {
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
  },
  props: {
    supervisorsAvailables: { type: Array, default: () => [] },
    readOnly: { type: Boolean, default: false },
    actualAdditionalInfo: { type: String, default: '' },
  },
  data() {
    return {
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      showDataBeforeSearchOption: false,
      nameSupervisors: [],
      additionalInfo: '',
    };
  },
  async beforeMount() {
    overlay.baseZIndex(9999);
    this.additionalInfo = this.actualAdditionalInfo;
    this.setAdditionalInfoWorkOrder(this.additionalInfo);
  },
  methods: {
    onSupervisorChange(e) {
      this.setSupervisorsLocation(e.value);
    },
    additionalInfoEvent(e) {
      const newValue = (e.value) ?? 0;
      this.setAdditionalInfoWorkOrder(newValue);
      this.additionalInfo = newValue;
    },
    ...mapActions('PlanningManager', ['setSupervisorsLocation', 'setAdditionalInfoWorkOrder']),
  },
};
</script>
<style>
.status-icon {
  height: 16px;
  width: 16px;
  display: inline-block;
  margin-right: 8px;
}
.middle {
  vertical-align: middle;
}
</style>
